module.exports = __webpack_public_path__ + "img/19.58b1011a.png";